module.exports = __webpack_public_path__ + "img/type_right_4.cf46751e.png";